module.exports = __webpack_public_path__ + "static/media/DJ_home_page.50b9afa6.PNG";